
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $4c3e55dfb549f378$exports = {};

$parcel$export($4c3e55dfb549f378$exports, "spectrum-IllustratedMessage", () => $4c3e55dfb549f378$export$e22c6753c239ec31, (v) => $4c3e55dfb549f378$export$e22c6753c239ec31 = v);
$parcel$export($4c3e55dfb549f378$exports, "spectrum-IllustratedMessage--cta", () => $4c3e55dfb549f378$export$29744d89c9a76d50, (v) => $4c3e55dfb549f378$export$29744d89c9a76d50 = v);
$parcel$export($4c3e55dfb549f378$exports, "spectrum-IllustratedMessage-description", () => $4c3e55dfb549f378$export$cf9d959111789fe7, (v) => $4c3e55dfb549f378$export$cf9d959111789fe7 = v);
$parcel$export($4c3e55dfb549f378$exports, "spectrum-IllustratedMessage-heading", () => $4c3e55dfb549f378$export$5df23faa5ed344c4, (v) => $4c3e55dfb549f378$export$5df23faa5ed344c4 = v);
var $4c3e55dfb549f378$export$e22c6753c239ec31;
var $4c3e55dfb549f378$export$29744d89c9a76d50;
var $4c3e55dfb549f378$export$cf9d959111789fe7;
var $4c3e55dfb549f378$export$5df23faa5ed344c4;
$4c3e55dfb549f378$export$e22c6753c239ec31 = `TtYriW_spectrum-IllustratedMessage`;
$4c3e55dfb549f378$export$29744d89c9a76d50 = `TtYriW_spectrum-IllustratedMessage--cta`;
$4c3e55dfb549f378$export$cf9d959111789fe7 = `TtYriW_spectrum-IllustratedMessage-description`;
$4c3e55dfb549f378$export$5df23faa5ed344c4 = `TtYriW_spectrum-IllustratedMessage-heading`;


export {$4c3e55dfb549f378$exports as default};
//# sourceMappingURL=illustratedmessage_vars_css.module.js.map
